import { getTwoLetterLanguageCode } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { convertLocaleToCountryLocaleString } from "@faire/web--source/common/localization/languageWithCountryOptions";
import { LocalizationStore } from "@faire/web--source/common/localization/LocalizationStore";
import { prependLocaleToUrl } from "@faire/web--source/ui/routing/util";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
/**
 * @deprecated Use `prependLocaleToUrl` and `RoutingContext` instead.
 */ export var localizePath = function(path) {
    var locale = LocalizationStore.get().locale;
    var canonicalLocale = getTwoLetterLanguageCode(Language.ENG).toLowerCase();
    var localeCountryUrlPrefix = getGlobalProperty("localeCountryUrlPrefix");
    var _getGlobalProperty;
    var availableLanguageSelectorLocales = ((_getGlobalProperty = getGlobalProperty("availableLanguageSelectorLocales")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : []).map(function(iLocaleKey) {
        return convertLocaleToCountryLocaleString(iLocaleKey);
    });
    return prependLocaleToUrl(path, {
        locale: locale,
        canonicalLocale: canonicalLocale,
        localeCountryUrlPrefix: localeCountryUrlPrefix,
        allowedRobotLocales: availableLanguageSelectorLocales
    });
};
